import React, { useState, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { StepProgressCounter } from './StepProgressCounter'
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from './EmblaCarouselArrowButtons'
import './StepProgress.scss'

const StepProgress = ({
  children,
  emblaApi: emblaApiProvided,
  emblaRef: emblaRefProvided,
  hasButtons,
  hasProgress,
}) => {
  const [emblaRefHook, emblaApiHook] = useEmblaCarousel({
    watchDrag: false,
  })

  const emblaRef = emblaRefProvided || emblaRefHook
  const emblaApi = emblaApiProvided || emblaApiHook

  const [actualSlide, setActualSlide] = useState(0)

  const handleSlideChange = useCallback(() => {
    if (!emblaApi) return
    setActualSlide(emblaApi?.selectedScrollSnap())
  }, [emblaApi])

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons({ emblaApi, handleSlideChange })

  return (
    <section className="embla_step_progress">
      {hasProgress && (
        <StepProgressCounter
          total={children.length}
          currentStep={actualSlide}
        />
      )}
      {hasButtons && (
        <>
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </>
      )}
      <div ref={emblaRef} className="embla__viewport">
        <div className="embla__container">
          {React.Children.map(children, (child, index) => (
            <div className="embla__slide_scrollable" key={index}>
              {child}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StepProgress
